import { isMobile } from "react-device-detect";
import GameSelector from "../v1/gameSelector.jsx";
import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Input, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Search from "@mui/icons-material/Search";
import { styles } from "./styles.js";

export default function SearchBox({
    groupData,
    controller,
    gamesIndex,
    favouritesData,
    onUpdateFavourites,
    cdnLocation,
    userContext,
    onPlayGame,
    onSearchForGames,
    searchResults,
    recommendedGames,
    onSearchClicked = () => {}
}) {
    const [showSearchResults, setShowSearchResults] = useState(isMobile ? true : false);
    const [localSearchResults, setLocalSearchResults] = useState(searchResults);
    const [searchString, setSearchString] = useState("");

    useEffect(() => {
        setLocalSearchResults(searchResults);
    }, [searchResults]);

    const searchForGames = (e) => {
        const value = e.target.value;
        setSearchString(value);
        setLocalSearchResults([]);
        if (value.length >= 3) {
            onSearchForGames(value);
        }
    };

    const handleSearchBoxFocusBlur = (e, value) => {
        if (showSearchResults) {
            return false;
        }
        setShowSearchResults(value);
    };

    const clearSearchString = () => {
        setSearchString("");
        setLocalSearchResults([]);
        onSearchForGames();
    };

    const onCloseSearch = () => {
        setShowSearchResults(false);
        setSearchString("");
        setLocalSearchResults([]);
        onSearchForGames();
        if (isMobile) {
            onSearchClicked();
        }
    };
    const props = {};
    if (!isMobile) {
        props.onFocus = (e) => handleSearchBoxFocusBlur(e, true);
    }

    return (
        <>
            {showSearchResults &&
                <Box sx={styles.overlay}></Box>
            }
            <Box sx={styles.searchBoxContainer} className={(showSearchResults ? " opened" : "") + (isMobile ? " is-mobile-version" : "")}>
                <Box sx={styles.inputGroup}>
                    <Typography component="span" className="search-icon cursor-pointer" sx={styles.searchIcon} onClick={(e) => handleSearchBoxFocusBlur(e, true)}><Search />{!isMobile && !showSearchResults && "Search"}</Typography>
                    {showSearchResults &&
                        <>
                            <Box sx={styles.searchBox} >
                                <Input
                                    sx={styles.searchBoxInput}
                                    id="search-box-input"
                                    placeholder="Search for games, slots, casino"
                                    onChange={(e) => searchForGames(e)}
                                    {...props}
                                    value={searchString}
                                />
                                {showSearchResults && searchString.length > 0 && <Button sx={styles.clearSearchStringBtn} onClick={clearSearchString}><CloseIcon /></Button>}
                            </Box>
                            <Button sx={styles.closeBtn} onClick={onCloseSearch}>Cancel</Button>
                        </>
                    }
                </Box>
                {showSearchResults &&
                    <Box sx={styles.resultsBoxContainer} className="resultsBoxContainer">
                        <Box sx={styles.resultsBox} className="resultsBox">
                            <Box sx={styles.gameResults} className={(localSearchResults.length === 0 && searchString.length < 3 ? "no-results" : "")}>
                                {localSearchResults.length === 0 && searchString.length >= 3 &&
                                    <>
                                        <Typography component="p" sx={styles.noResultsImage}></Typography>
                                        <Typography component="p" sx={{ ...styles.headerText, ...{ textAlign: "center", fontWeight: "normal", marginTop: "10px" } }}>Sorry, we couldn’t find any results</Typography>
                                    </>
                                }
                                {localSearchResults.length > 0 &&
                                    <>
                                        <Typography component="p" sx={styles.headerText}>Search results for &quot;{searchString}&quot;</Typography>
                                        <Box sx={styles.resultsList}>
                                            {localSearchResults.map((result) => {
                                                return (
                                                    <GameSelector
                                                        key={GBEUtils.createUUID()}
                                                        gamesData={groupData}
                                                        game={result}
                                                        controller={controller}
                                                        gamesIndex={gamesIndex}
                                                        favouritesData={favouritesData}
                                                        onUpdateFavourites={onUpdateFavourites}
                                                        cdnLocation={cdnLocation}
                                                        userContext={userContext}
                                                        onPlayGame={onPlayGame}
                                                        colName={"col-6 p-1"}
                                                        fromSearch={true}
                                                    />
                                                );
                                            })}
                                        </Box>
                                    </>
                                }
                            </Box>
                            {recommendedGames.length > 0 &&
                                <Box sx={styles.gameResults}>
                                    <Divider light sx={{ borderBottomWidth: "2px", marginBottom: "20px" }} />
                                    <Typography component="p" sx={styles.headerText}>Try out our recommended games:</Typography>
                                    <Box sx={styles.resultsList}>
                                        {recommendedGames.slice(0, 4).map((recommendedGame) => {
                                            let gameDetails;
                                            groupData.forEach((group) => {
                                                group.gamesDetails.forEach((element) => {
                                                    if (element.id === recommendedGame) {
                                                        gameDetails = element;
                                                    }
                                                });
                                            });
                                            if (gameDetails) {
                                                return (
                                                    <GameSelector
                                                        key={GBEUtils.createUUID()}
                                                        gamesData={groupData}
                                                        game={gameDetails}
                                                        controller={controller}
                                                        gamesIndex={gamesIndex}
                                                        favouritesData={favouritesData}
                                                        onUpdateFavourites={onUpdateFavourites}
                                                        cdnLocation={cdnLocation}
                                                        userContext={userContext}
                                                        onPlayGame={onPlayGame}
                                                        colName="col-6 p-1"
                                                        fromSearch={true}
                                                    />
                                                );
                                            } else {
                                                return false;
                                            }
                                        })}
                                    </Box>
                                </Box>
                            }
                        </Box>
                    </Box>
                }
            </Box>
        </>
    );
}